import { useEffect, useState } from "react";
import Select from 'react-select';
import { ddStyles } from "../utils/CommonStyles.js";

let locationOptions = [];
let supplierDateOptions = [];
function SupplierLocationTableRow({ key, companyLocationList, supplierDates, handleSubmit, setError, t, setAdd, setIsLocationLoading, oddIdx }) {

    const [locationLoaded, setLocationLoaded] = useState(false);
    const [locationSelected, setLocationSelected] = useState({ name: "locationKey", label: "", value: 0 });
    const [supplierDateLoaded, setSupplierDateLoaded] = useState(false);
    const [supplierDatesSelected, setSupplierDatesSelected] = useState([]);
    const [isSubmit, setIsSubmit] = useState(false);
    const [partnerNumber, setPartnerNumber] = useState("");
    useEffect(() => {
        setLocationValues(companyLocationList);
        setSupplierDates(supplierDates);
    }, []);

    const locationHandler = (selectedOption, action) => {
        let locationKey = selectedOption ? selectedOption.value : 0;
        let locationName = selectedOption ? selectedOption.label : "";
        setLocationSelected({ ...locationSelected, label: (locationName), value: locationKey });
    }

    function setLocationValues(locationObj) {
        let locationValue = {};
        locationOptions = [];
        locationOptions.push({ label: "", value: 0 });
        if (locationObj && locationObj.length > 0) {
            locationObj.map((aLoc, idx) => {
                locationValue.label = aLoc.locationName + "-" + aLoc.departmentName;
                locationValue.value = aLoc.locationKey;
                locationOptions.push(locationValue);
                locationValue = {};
            });
            setLocationLoaded(true);
        }
    }
	
	function setSupplierDates(supplierDatesList) {
        let supplierDateValue = {};
        supplierDateOptions = [];
        if (supplierDatesList && supplierDatesList.length > 0) {
            supplierDatesList.map((aSupplierDate, idx) => {
                supplierDateValue.label = aSupplierDate.startDate + " - " + aSupplierDate.endDate;
                supplierDateValue.value = aSupplierDate.partnershipDateKey;
                supplierDateOptions.push(supplierDateValue);
                supplierDateValue = {};
            });
            setSupplierDateLoaded(true);
        }
    }
    const supplierDateHandler = (selectedOptions) => {
		//console.log(selectedOptions);
        setSupplierDatesSelected(selectedOptions);
    }

    function submitComplete() {
        setIsSubmit(false);
        setSupplierDatesSelected([]);
    }
    function submitRow() {
        setError("");
        setIsSubmit(true);
        let initialValues = {
            locationKey: locationSelected.value,
            partnerNumber: partnerNumber,
            partnershipDateKeys: supplierDatesSelected.map(option => option.value),
        };

        if (!locationSelected.value || locationSelected.value === 0) {
            setError(t("error.locNameReqd"));
            setIsSubmit(false);
        } else {
            handleSubmit(1, initialValues, submitComplete);
        }

    }
    function submitCancel() {
        setError("");
        setAdd(false);
        setSupplierDatesSelected([]);
    }
    function changePartnerNumber(newPartnerNumber) {
        let partnerNameRegEx = /^[a-zA-Z0-9_-]+$/;
        if (newPartnerNumber) {
            if (!partnerNameRegEx.test(newPartnerNumber)) {
                errors.push(t("error.partnerNumber.invalid"));
                setPartnerNumber("");
            } else {
                setPartnerNumber(newPartnerNumber);
            }
        }
    }
    return (
        <tr key={key}>
            <td className={oddIdx ? "list-td col odd" : "list-td col even"}></td>
            <td className={oddIdx ? "list-td col odd" : "list-td col even"}>
                {locationLoaded ? <Select
                    name="locationKey"
                    options={locationOptions}
                    onChange={locationHandler}
                    placeholder={""}
                    value={locationSelected}
                    isSearchable={true}
                    isClearable={true}
                    className="myselect"
                    inputId="locationKey-input"
                    styles={ddStyles}
                />
                    : <></>}
            </td>
            <td className={oddIdx ? "list-td col odd" : "list-td col even"}></td>
            <td className={oddIdx ? "list-td col text-wrap odd" : "list-td col text-wrap even"}>
                <input
                    type="text"
                    name="partnerNumber"
                    id="partnerNumber"
                    value={partnerNumber}
                    onChange={(e) => changePartnerNumber(e.target.value)}
                    maxLength="50"
                    placeholder={t("page.suplrNumber")}
                    className="form-control rounded-pill shadow-sm px-4 "
                />
            </td>
            <td className={oddIdx ? "list-td col odd" : "list-td col even"}>
                {supplierDateLoaded ? <Select
                    name="supplierDateKey"
                    options={supplierDateOptions}
                    onChange={supplierDateHandler}
                    placeholder={""}
                    value={supplierDatesSelected}
                    isSearchable={true}
                    isClearable={true}
                    className="myselect"
                    inputId="supplierDateKey-input"
                    isMulti
                    styles={ddStyles}
                />
                : <></>}
            </td>
            <td className={oddIdx ? "list-td col odd" : "list-td col even"}>{t("page.active")}</td>
            <td className={oddIdx ? "list-td col odd" : "list-td col even"}>
                <div id="submit-spinner"
                    className={isSubmit ? "spinner-border spinner-border-sm text-dark spinner-size" : "spinner-hide"}
                >
                </div>
                {(locationOptions && locationOptions.length > 0) ?
                    (<button className={isSubmit ? "btn btn-primary btn-block me-4 mb-1 pe-none" : "btn btn-primary btn-block me-4 mb-1"} onClick={() => (submitRow())}>{t("page.submit")}</button>)
                    :
                    (<></>)
                }
                <button className={isSubmit ? "btn btn-primary btn-block me-4 mb-1 pe-none" : "btn btn-primary btn-block me-4 mb-1"} onClick={() => (submitCancel())}>{t("page.cancel")}</button>
            </td>
        </tr>
    )

}
export default SupplierLocationTableRow;